import { render, staticRenderFns } from "./tagList.vue?vue&type=template&id=7c4c2f34&scoped=true&"
import script from "./tagList.vue?vue&type=script&lang=js&"
export * from "./tagList.vue?vue&type=script&lang=js&"
import style0 from "./tagList.vue?vue&type=style&index=0&id=7c4c2f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4c2f34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VIcon,VRow,VTextField})
